import { Schema as S } from "effect";

/**
 * Patient candidate offered by the card-matching workflow.
 * @since 1.1.11
 * @example
 * const value = MatchedPatient.make({ id: "patient-1", givenName: "", familyName: "", birthDate: "" });
 */
export const MatchedPatient = S.Struct({
  id: S.String,
  givenName: S.String,
  familyName: S.String,
  birthDate: S.String,
  address: S.optional(
    S.Struct({
      street: S.optional(S.String),
      houseNumber: S.optional(S.String),
      zip: S.optional(S.String),
      city: S.optional(S.String),
      country: S.optional(S.String),
    })
  ),
  patientNumber: S.optional(S.String),
});
/**
 * Decoded value of {@link MatchedPatient}.
 * @since 1.1.11
 * @example
 * const value: MatchedPatient = { id: "patient-1", givenName: "", familyName: "", birthDate: "" };
 */
export type MatchedPatient = S.Schema.Type<typeof MatchedPatient>;
